/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the state of the subscription:
 *   * ENABLED : The subscription is fully ENABLED
 *   * PLANNED_ENABLED : The subscription is DISABLED but is planned to become ENABLED at a specified date
 *   * DISABLED: The subscription is fully DISABLED
 *   * PLANNED_DISABLED: The subscription is ENABLED but is planned to become DISABLED at a specified date
 */
export enum SubscriptionState {
  ENABLED = 'ENABLED',
  PLANNED_ENABLED = 'PLANNED_ENABLED',
  DISABLED = 'DISABLED',
  PLANNED_DISABLED = 'PLANNED_DISABLED'
}
